import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateCompanyApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateCompany = createAsyncThunk('updateCompany', async (payload) => {
  return await updateCompanyApi(payload);
});

const updateCompanySlice = createSlice({
  name: 'updateCompany', // Unique Name
  initialState,
  reducers: {
    updateCompanyReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCompany.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateCompany.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateCompany.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateCompanyReset } = updateCompanySlice.actions;

export default updateCompanySlice.reducer;
